import Prism from "@theme-ui/prism";

const compo = {
  pre: (props) => props.children,
  code: Prism,
}

export default compo;